<h2 *ngIf="item.hasMechanicalAspect">Mechanical</h2>
<app-mechanical-aspect-item *ngIf="item.hasMechanicalAspect" [readOnly]="readOnly" [createMode]="createMode"
  [item]="item.mechanicalAspect" [asset]="item"></app-mechanical-aspect-item>

<mat-divider *ngIf="item.hasMechanicalAspect"></mat-divider>

<h2 *ngIf="item.hasElectricalAspect">Electrical</h2>
<app-electrical-aspect-item *ngIf="item.hasElectricalAspect" [readOnly]="readOnly" [createMode]="createMode"
  [item]="item.electricalAspect" [asset]="item"></app-electrical-aspect-item>

<mat-divider *ngIf="item.hasElectricalAspect"></mat-divider>

<h2 *ngIf="item.hasMaintenanceAspect">Maintenance</h2>
<app-maintenance-aspect-item *ngIf="item.hasMaintenanceAspect" [readOnly]="readOnly" [createMode]="createMode"
  [item]="item.maintenanceAspect" [asset]="item"></app-maintenance-aspect-item>

<mat-divider *ngIf="item.hasMaintenanceAspect"></mat-divider>

<div class="crud-item-section" *ngIf="!readOnly">
  <button *ngIf="isAspectAllowed('MechanicalAspect') && !item.hasMechanicalAspect" mat-raised-button
    (click)="addAspect('MechanicalAspect')" i18n="@@actions.Asset.addMechanicalAspect">Add Mechanical Info</button>
  <button *ngIf="!isAspectRequired('MechanicalAspect') && item.hasMechanicalAspect" mat-raised-button color="accent2" (click)="removeAspect('MechanicalAspect')"
    i18n="@@actions.Asset.removeMechanicalAspect">Remove Mechanical
    Info</button>
  <button *ngIf="isAspectAllowed('ElectricalAspect') && !item.hasElectricalAspect" mat-raised-button
    (click)="addAspect('ElectricalAspect')" i18n="@@actions.Asset.addElectricalAspect">Add Electrical Info</button>
  <button *ngIf="!isAspectRequired('ElectricalAspect') && item.hasElectricalAspect" mat-raised-button color="accent2" (click)="removeAspect('ElectricalAspect')"
    i18n="@@actions.Asset.removeElectricalAspect">Remove Electrical
    Info</button>
  <button *ngIf="isAspectAllowed('MaintenanceAspect') && !item.hasMaintenanceAspect" mat-raised-button
    (click)="addAspect('MaintenanceAspect')" i18n="@@actions.Asset.addMaintenanceAspect">Add Maintenance Info</button>
  <button *ngIf="!isAspectRequired('MaintenanceAspect') && item.hasMaintenanceAspect" mat-raised-button color="accent2"
    (click)="removeAspect('MaintenanceAspect')" i18n="@@actions.Asset.removeMaintenanceAspect">Remove Maintenance
    Info</button>
</div>